module.exports = __webpack_public_path__ + "img/sld_mfm_ic_1_b1_dark.fbe2faa3.svg";